// OneDrive:IgnoreCodeCoverage

import IPrefetchData from './IPrefetchData';
import * as Features from './Features';
import * as ListItemPostDataHelpers from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/ListItemPostDataHelpers';
import { ISPGetItemPostDataContext } from '@ms/odsp-datasources/lib/SPListItemRetriever';
import { IFeature } from '@ms/odsp-utilities/lib/features/Features';

export class PrefetchData implements IPrefetchData {
    public completedCallback?: (responseCode: number) => void;
    public correlationId?: string;
    public startTimeMark: number;
    public serverDuration?: number;
    public responseCode?: number;
    public listData?: any; // tslint:disable-line:no-any
    public deferredListData: boolean;
    public contentTypesCallback?: () => void;

    constructor() {
        this.startTimeMark = new Date().getTime();
        this.deferredListData = false;
    }
}

export class ListViewDataPrefetchHelper {
    // tslint:disable-next-line:no-inferrable-types
    public static shouldLogError: boolean = true;
    private static _prefetchData: { [hashCode: string]: IPrefetchData };

    public static prefetchData(hashCode: string): IPrefetchData | null {
        return ListViewDataPrefetchHelper._prefetchData ? ListViewDataPrefetchHelper._prefetchData[hashCode] : null;
    }

    public static initPrefetchData(hashCode: string): IPrefetchData {
        if (!ListViewDataPrefetchHelper._prefetchData) {
            ListViewDataPrefetchHelper._prefetchData = {};
        }
        return ListViewDataPrefetchHelper._prefetchData[hashCode] = new PrefetchData();
    }

    public static setPrefetchData(hashCode: string, newPrefetchData: IPrefetchData): void {
        if (!ListViewDataPrefetchHelper._prefetchData) {
            ListViewDataPrefetchHelper._prefetchData = {};
        }
        ListViewDataPrefetchHelper._prefetchData[hashCode] = newPrefetchData;
    }

    public static clearPrefetchData(hashCode: string): void {
        if (ListViewDataPrefetchHelper._prefetchData && ListViewDataPrefetchHelper._prefetchData[hashCode]) {
            delete ListViewDataPrefetchHelper._prefetchData[hashCode];
        }
    }

    public static getAdditionalPostData(params: ISPGetItemPostDataContext, isFeatureEnabled?: ((feature: IFeature) => boolean)): string {
        params.isListDataRenderOptionChangeFeatureEnabled = !isFeatureEnabled || isFeatureEnabled(Features.ListDataRenderOptionChange);
        params.isSpotlightFeatureEnabled = true;
        return ListItemPostDataHelpers.getAdditionalPostData(params);
    }

    public static createHashCode(url: string, payload: string): string {
        // tslint:disable-next-line:max-line-length
        return `listviewdataprefetch-${ListViewDataPrefetchHelper._hashCode(decodeURIComponent(url))}-${ListViewDataPrefetchHelper._hashCode(payload)}`;
    }

    private static _hashCode(content: string): number {
        let hash = 0;
        if (!content || content.length === 0) {
            return hash;
        }
        /* tslint:disable:no-bitwise */
        for (let i = 0; i < content.length; i++) {
            const chr = content.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
        /* tslint:enable:no-bitwise */
    }
}

export default ListViewDataPrefetchHelper;
